import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ArrowRight, X } from 'lucide-react';
import { trialIntent, clearTrialIntent, attributeTrial, existingSession } from './sampleClient';

export const LandingTrialHandoff = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [intent, setIntent] = useState(null);
  useEffect(() => {
    if (pathname !== '/overview' || !existingSession()) { setIntent(null); return; }
    const pending = trialIntent();
    setIntent(pending);
    if (pending) attributeTrial(pending);
  }, [pathname]);
  if (!intent) return null;
  return <aside data-testid="sample-trial-handoff" className="border-b border-blue-100 bg-blue-50 px-4 py-3 flex items-center justify-center gap-3 flex-wrap text-sm text-slate-800">
    <span>Your requested subject: <strong data-testid="sample-handoff-subject">{intent.subject}</strong></span>
    <button data-testid="sample-handoff-research" className="inline-flex items-center gap-1 text-blue-800 underline" onClick={() => { clearTrialIntent(); setIntent(null); navigate(`/search?q=${encodeURIComponent(intent.subject)}`); }}>Continue research <ArrowRight size={14} /></button>
    <button data-testid="sample-handoff-dismiss" aria-label="Dismiss requested subject" onClick={() => { clearTrialIntent(); setIntent(null); }}><X size={16} /></button>
  </aside>;
};